<script lang="ts" setup>
import type { AcceptedFilter, Sort } from '../../../Models'

const emits = defineEmits<{
  (e: 'remove', model: AcceptedFilter): void
}>()

const props = withDefaults(
  defineProps<{
    filters?: AcceptedFilter[]
    sort?: Sort
    hiddenFilters?: string[]
  }>(),
  {
    filters: () => [],
    sort: undefined,
    hiddenFilters: () => [],
  },
)

const filtersKeysForRender = computed(() => {
  return props.filters.filter(f => !props.hiddenFilters.includes(f.key) && f.value !== undefined)
})

function remove(model: AcceptedFilter) {
  emits('remove', model)
}
</script>

<template>
  <div v-show="props.filters.length" class="flex flex-wrap items-center gap-2">
    <div
      v-for="(filter, idx) in filtersKeysForRender"
      :key="filter.label + idx"
      class="bg-surface-900 text-surface-50 flex items-center gap-2 rounded-full px-4 py-1 text-xs"
    >
      <span>{{ filter.label }}</span>
      <button type="button" class="flex cursor-pointer items-center" @click="remove(filter)">
        <Icon name="icon:close" class="text-[0.5rem]" />
      </button>
    </div>
  </div>
</template>
